import { render, staticRenderFns } from "./order-categorias.vue?vue&type=template&id=7ebc4cc1&scoped=true"
import script from "./order-categorias.vue?vue&type=script&lang=js"
export * from "./order-categorias.vue?vue&type=script&lang=js"
import style0 from "./order-categorias.vue?vue&type=style&index=0&id=7ebc4cc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebc4cc1",
  null
  
)

export default component.exports